/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

function Draw(canvas, size) {
    this.canvas = canvas
    this.size = size
    var context = this.getContext()

    var devicePixelRatio = window.devicePixelRatio || 1
    var backingStorePixelRatio = context.webkitBackingStorePixelRatio
        || context.mozBackingStorePixelRatio
        || context.msBackingStorePixelRatio
        || context.oBackingStorePixelRatio
        || context.backingStorePixelRatio
        || 1

    var pixelRatio = devicePixelRatio / backingStorePixelRatio

    canvas.style.width = size.w + 'px'
    canvas.style.height = size.h + 'px'
    canvas.width = size.w * pixelRatio
    canvas.height = size.h * pixelRatio
    canvas.paintCodePixelRatio = pixelRatio

    this.size = Draw.makeSize(size.w, size.h)
    this.pixelRatio = pixelRatio

    context.scale(pixelRatio, pixelRatio)
}

Draw.makeRect = function(x, y, w, h) {
    return { x: x, y: y, w: w, h: h }
}

Draw.equalRects = function(r1, r2) {
    return r1.x === r2.x && r1.y === r2.y && r1.w === r2.w && r1.h === r2.h
}

Draw.makeSize = function(w, h) {
    return { w: w, h: h }
}

Draw.makePoint = function(x, y) {
    return { x: x, y: y }
}

Draw.equalPoints = function(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y
}

Draw.prototype.rect = function(rect, options) {
    var defaultOptions = {}
    var opts = this.merge(defaultOptions, options)

    var context = this.getContext()
    context.save()
    context.beginPath()

    context.rect(rect.x, rect.y, rect.w, rect.h)
    if (opts['fill'] !== undefined)
    {
        context.fillStyle = opts.fill
        context.fill()
    }

    if (opts['stroke'] !== undefined && opts['lineWidth'] !== undefined)
    {
        context.strokeStyle = opts.stroke
        context.lineWidth = opts.lineWidth
        context.stroke()
    }

    context.restore()
}

Draw.prototype.oval = function(rect, options) {
    var defaultOptions = {lineWidth: 1}
    var opts = this.merge(defaultOptions, options)

    var context = this.getContext()
    context.save()
    context.beginPath()

    context.translate(rect.x, rect.y)
    context.scale(rect.w/2, rect.h/2)
    context.arc(1, 1, 1, 0, 2*Math.PI, false)
    context.closePath()

    context.restore()
    context.save()

    if (opts['fill'] !== undefined)
    {
        context.fillStyle = opts.fill
        context.fill()
    }

    if (opts['stroke'] !== undefined)
    {
        context.strokeStyle = opts.stroke
        context.lineWidth = opts.lineWidth
        context.stroke()
    }

    context.restore()
}

Draw.prototype.line = function(from, to, options) {
    var defaultOptions = {strokeStyle: 'rgb(255, 255, 255)', lineWidth: 1}
    var opts = this.merge(defaultOptions, options)

    var context = this.getContext()
    context.save()
    context.beginPath()

    context.moveTo(from.x, from.y)
    context.lineTo(to.x, to.y)
    context.strokeStyle = opts.stroke
    context.lineWidth = opts.lineWidth
    context.stroke()

    context.restore()
}

Draw.prototype.text = function(text, rect, options = {}) {
    var dopts = {
        fill: 'rgb(255, 255, 255)',
        font: 'Avenir, sans-serif',
        fontWeight: 'bold',
        fontSize: 20,
        textAlign: 'center'
    }
    var opts = this.merge(dopts, options)

    var context = this.getContext()
    context.save()

    context.fillStyle = opts.fill
    context.font = opts.fontWeight + ' ' + opts.fontSize + 'px ' + opts.font
    context.textAlign = opts.textAlign
    var textTotalHeight = opts.fontSize * 1.3

    var x = rect.x + rect.w/2
    var y = rect.y + opts.fontSize + rect.h/2 - textTotalHeight/2
    context.fillText(text, x, y)

    context.restore()
}

Draw.prototype.clear = function() {
    var context = this.getContext()
    context.clearRect(0, 0, this.size.w, this.size.h)
}

Draw.prototype.merge = function(a, b) {
    var aKeys = Object.keys(a)
    var bKeys = Object.keys(b)
    var c = {}

    for (var i = 0; i < aKeys.length; i++)
    {
        var key = aKeys[i]
        c[key] = a[key]
    }

    for (i = 0; i < bKeys.length; i++)
    {
        key = bKeys[i]
        c[key] = b[key]
    }

    return c
}

Draw.prototype.getContext = function() {
    return this.canvas.getContext('2d')
}


module.exports = Draw
